import * as React from 'react';
import { Typography } from '@mui/material';
import { theme } from '../../utils/themeProvider.js';
import '@mui/styles';
import '@mui/material/styles';
import keygen from 'uuid/v4';
import { Button } from '../Button/Button.js';
import { Icon } from '../Icon/Icon.js';
import { LayoutGrid } from '../LayoutGrid/LayoutGrid.js';
var styles = {
  label: {
    color: 'primary.main'
  },
  lastNode: {
    color: 'text.primary'
  },
  crumbsWrapper: {
    '&>button': {
      padding: 0,
      minWidth: '0',
      minHeight: '0',
      '&>span>svg': {
        height: 3,
        width: 3
      },
      '& p': {
        textTransform: 'none'
      },
      '& p.labelBody2': {
        fontSize: 'body2.fontSize',
        fontWeight: 'body2.fontWeight',
        lineHeight: 'initial',
        textAlign: 'left'
      },
      '& p.labelBody1': {
        fontSize: 'body1.fontSize',
        fontWeight: 'body1.fontWeight',
        lineHeight: 'initial',
        color: 'text.primary'
      }
    }
  },
  crumbChevron: {
    margin: 0,
    height: theme.spacing(2.5),
    width: theme.spacing(2.5),
    color: 'grey.900'
  }
};

var Breadcrumb = function Breadcrumb(_ref) {
  var items = _ref.items,
      sx = _ref.sx;
  var label = styles.label,
      lastNode = styles.lastNode,
      crumbsWrapper = styles.crumbsWrapper,
      crumbChevron = styles.crumbChevron;
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": "breadcrumb"
  }, /*#__PURE__*/React.createElement(LayoutGrid, {
    container: true,
    direction: "row",
    justify: "flex-start",
    alignItems: "center",
    sx: [crumbsWrapper, sx]
  }, items.map(function (crumb, index, allCrumbs) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: keygen()
    }, !crumb.labelName && !crumb.text ? /*#__PURE__*/React.createElement(Button, {
      disabled: allCrumbs.length > 1 && index === allCrumbs.length - 1,
      onClick: crumb.onClick,
      icon: crumb.icon,
      label: crumb.icon
    }) : /*#__PURE__*/React.createElement(Button, {
      disabled: allCrumbs.length > 1 && index === allCrumbs.length - 1,
      onClick: crumb.onClick,
      icon: crumb.icon,
      iconPosition: "left",
      size: "small",
      label: crumb.icon,
      "aria-current": allCrumbs.length >= 2 && index === allCrumbs.length - 2
    }, crumb.labelName && /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: "labelBody2",
      sx: allCrumbs.length > 1 && index === allCrumbs.length - 1 ? lastNode : label,
      "aria-label": crumb.labelName
    }, crumb.labelName), crumb.text && /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      className: "labelBody1",
      sx: allCrumbs.length > 1 && index === allCrumbs.length - 1 ? lastNode : undefined,
      "aria-label": crumb.text
    }, crumb.text)), index !== allCrumbs.length - 1 ? /*#__PURE__*/React.createElement(Icon, {
      icon: "ChevronRight",
      fontSize: "small",
      sx: crumbChevron
    }) : null);
  })));
};

Breadcrumb.displayName = 'BreadCrumb';
export { Breadcrumb };